import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// The design system's type scale lives outside Tailwind's defaults, so
// tailwind-merge has to be told these are font sizes — otherwise it treats
// them as text colors and drops them when a color class follows.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["micro", "meta", "label", "body", "title", "head"] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount)
}

export function shortMoney(amount: number): string {
  const sign = amount < 0 ? "-" : ""
  const value = Math.abs(amount)
  if (value >= 1_000_000) return `${sign}$${+(value / 1_000_000).toFixed(2)}M`
  if (value >= 1_000) return `${sign}$${+(value / 1_000).toFixed(1)}K`
  return `${sign}$${Math.round(value)}`
}
